import React from 'react';
import {
  Button,
  CloseButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextList,
  ThemeProvider,
} from '@ui';
import { Typography } from '../common/Typography';

export type UnappliedCreditsAvailableDialogProps = {
  open: boolean;
  onContinue?: () => void;
  onClose?: () => void;
};

export const UnappliedCreditsAvailableDialog: React.FC<UnappliedCreditsAvailableDialogProps> = ({
  onContinue,
  onClose,
  open,
}) => (
  <ThemeProvider>
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Unapplied Credits Available
        <CloseButton onClick={onClose} />
      </DialogTitle>

      <DialogContent>
        <Typography>
          There are unapplied credits available, which can be used with your invoices or debit
          memos.
        </Typography>

        <TextList>
          <TextList.Item>
            Please contact our licensing team if you wish to apply them.
          </TextList.Item>
          <TextList.Item>
            If you want to proceed to payment without applying credits, press "Continue".
          </TextList.Item>
        </TextList>
      </DialogContent>

      <DialogActions>
        <Button
          color='primary'
          size='small'
          variant='outlined'
          href='https://enscape3d.com/contact/'
          target='_blank'
        >
          Contact
        </Button>

        <Button color='primary' size='small' variant='contained' onClick={onContinue}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  </ThemeProvider>
);
